var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import styles from './index.css';
import auth from '../../../../../../base/auth';
import { cookie } from '../../../../../../base/base';
import { LoginIdContext } from '../../../utils/loginId';
import CommentTextarea from '../../commentTextarea';
import { vote } from '../../../utils/api';
class BottomBar extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            userInfo: auth.isLogin() ? auth.getUserInfo() : null,
            uptimes: this.props.content.uptimes ? this.props.content.uptimes : 0,
            replayShow: true,
            curPage: this.props.curPage,
        };
        // 推荐评论内容或者回复的内容
        this.handleRecommend = () => __awaiter(this, void 0, void 0, function* () {
            let { uptimes } = this.state;
            const { config: { cmtVoteUrl, docUrl }, content: { comment_id }, } = this.props;
            try {
                if (auth.isLogin()) {
                    const data = yield vote(cmtVoteUrl, comment_id, docUrl);
                    if (data.code === 1) {
                        uptimes += 1;
                        this.setState({ uptimes });
                    }
                }
                else {
                    window.alert('登录之后才能推荐哦，请先登录');
                }
            }
            catch (e) {
                console.error(e);
            }
        });
        this.handleReplayShow = () => {
            const { replayShow } = this.state;
            const { setReplyId, content: { comment_id }, replyId, } = this.props;
            if (replyId === comment_id) {
                this.setState({ replayShow: !replayShow });
            }
            else {
                setReplyId(comment_id);
            }
        };
        this.handleJub = () => {
            const { loginId, handleJubShow, content: { comment_id }, } = this.props;
            if (auth.isLogin()) {
                // window.alert('您还没有实名认证，请先进行实名认证');
                // 修改model的jubao状态
                // 判断举报时间间隔
                const timeClick = Number(new Date().getTime());
                const jubTime = cookie.get('jubTime') && cookie.get('jubTime') !== '' ? Number(cookie.get('jubTime')) : 0;
                // 大于一分钟，则弹出举报框，并且更新model的闹钟
                if (timeClick - jubTime >= 60000) {
                    // 时间太短，则更新model的时间，给出提示框，不能举报
                    cookie.set('jubTime', timeClick.toString(), '', '', 0, '');
                    if (handleJubShow)
                        handleJubShow(comment_id);
                }
                else {
                    window.alert('您举报的过于频繁，请稍作休息。');
                    return;
                }
            }
            else {
                window.alert('您还没有登录，请先登录');
                // 弹出登陆框
                auth.login(loginId);
                // 登录成功后，打开举报框，进行举报
                this.unBindJubaoLogin = auth.event.on(auth.EVENTNAMES.login, () => {
                    if (handleJubShow)
                        handleJubShow(comment_id);
                });
            }
        };
    }
    componentDidMount() {
        cookie.del('jubTime', '', '');
        this.unBindLogin = auth.event.on(auth.EVENTNAMES.login, (userInfo) => {
            this.setState({
                userInfo,
            });
        });
        this.unBindLogout = auth.event.on(auth.EVENTNAMES.logout, () => {
            this.setState({
                userInfo: null,
            });
        });
    }
    componentWillUnmount() {
        this.unBindLogin();
        this.unBindLogout();
    }
    static getDerivedStateFromProps(props, state) {
        let resUptimes = {};
        let resreplayShow = {};
        if (props.content.uptimes !== state.uptimes && props.curPage !== state.curPage) {
            resUptimes = { uptimes: props.content.uptimes, curPage: props.curPage };
        }
        if (props.replyId !== props.content.comment_id) {
            resreplayShow = {
                replayShow: true,
            };
        }
        return Object.assign(Object.assign({}, resUptimes), resreplayShow);
        // return null;
    }
    render() {
        const { uptimes, replayShow } = this.state;
        const { content: { comment_id, year, date, time }, replyId, jubCommentIdArr, } = this.props;
        // console.log(uptimes, '----', this.props.content.uptimes);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.bottom_bar },
                comment_id ? (React.createElement("span", { className: styles.reply },
                    React.createElement("span", null,
                        React.createElement("a", { onClick: this.handleRecommend, style: { cursor: 'pointer' } },
                            React.createElement("span", null, "\u63A8\u8350"),
                            React.createElement("em", { className: styles.repNum }, uptimes)),
                        React.createElement("em", { className: styles.repLine }, "/"),
                        React.createElement("a", { onClick: this.handleReplayShow }, replayShow && comment_id === replyId ? '取消' : '回复'),
                        React.createElement("em", { className: styles.repLine }, "/"),
                        jubCommentIdArr && jubCommentIdArr.indexOf(comment_id || '') > -1 ? (React.createElement("span", { className: styles.reported }, "\u5DF2\u4E3E\u62A5")) : (React.createElement("a", { onClick: this.handleJub }, "\u4E3E\u62A5"))))) : null,
                React.createElement("span", { className: styles.comment_time },
                    year,
                    "-",
                    date,
                    "-",
                    time)),
            React.createElement("div", { style: { display: replayShow && comment_id === replyId ? 'block' : 'none' }, className: styles.bottom_box },
                React.createElement(LoginIdContext.Consumer, null, (value) => (React.createElement(CommentTextarea, { content: value.config, loginId: value.loginId, config: value.config, userInfo: value.userInfo, myComUrl: value.myComUrl, commentId: comment_id, headShow: false }))))));
    }
}
export default BottomBar;
